var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-rank__two-columns" },
    [
      !_vm.styleObject.hideHeader &&
      (!_vm.styleObject.hideTitle ||
        (_vm.styleObject.hideTitle &&
          (_vm.styleObject.hideMyRank ||
            !_vm.rankData.rankList ||
            !_vm.rankData.rankList.length)))
        ? _c(
            "rank-title",
            {
              class: {
                "yxtbiz-rank__two-columns-title":
                  !_vm.styleObject.hideHeader &&
                  (!_vm.styleObject.hideTitle || _vm.titleObj.showDate),
              },
              on: {
                changeDate: function ($event) {
                  return _vm.$emit("changeDate", $event)
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "title" }, slot: "title" },
                [_vm._t("title")],
                2
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          class: {
            "yxtbiz-rank__two-columns-no-data":
              _vm.height &&
              (!_vm.rankData.rankList || !_vm.rankData.rankList.length),
          },
          style: { height: _vm.height ? _vm.height - 88 + "px" : "auto" },
        },
        [
          _vm.rankData.rankList && _vm.rankData.rankList.length
            ? _c(
                "yxtf-scrollbar",
                { ref: "scrollBox", attrs: { "fit-height": "" } },
                [
                  !_vm.styleObject.hideMyRank
                    ? _c(
                        "my-rank",
                        {
                          class: [
                            _vm.styleObject.showStyle === 1 ? "mb16" : "mb32",
                          ],
                          attrs: {
                            myRankData: _vm.rankData.myRankData,
                            styleType: 2,
                          },
                          on: {
                            changeDate: function ($event) {
                              return _vm.$emit("changeDate", $event)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._t("title")],
                            2
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.styleObject.showStyle === 2
                    ? _c("horizontal-head", {
                        staticClass: "mt32",
                        attrs: {
                          "rank-data": _vm.rankData.rankList.slice(0, 3),
                        },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-1 yxtbiz-rank__two-columns-first-line",
                      },
                      _vm._l(_vm.firstLine, function (item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [_c("row-item", { attrs: { rowData: item } })],
                          1
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-1 yxtbiz-rank__two-columns-second-line",
                      },
                      _vm._l(_vm.secondLine, function (item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [_c("row-item", { attrs: { rowData: item } })],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.initFlag < 1
                    ? _c(
                        "yxtf-empty",
                        {
                          attrs: {
                            size: "small",
                            "empty-text": _vm.apiError
                              ? _vm
                                  .$t("pc_biz_rank_no_server")
                                  .d("哎呀~服务器开小差啦~")
                              : _vm.$t("pc_biz_lbl_nodata").d("暂无数据"),
                          },
                        },
                        [
                          _vm.apiError
                            ? _c(
                                "div",
                                { attrs: { slot: "image" }, slot: "image" },
                                [
                                  _c("yxt-svg", {
                                    attrs: {
                                      "remote-url":
                                        _vm.$staticBaseUrl +
                                        "ufd/3f5568/common/h5/svg/",
                                      "icon-class": "no-server",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }